import { render, staticRenderFns } from "./TeacherEylf.vue?vue&type=template&id=50bd2b12&"
import script from "./TeacherEylf.vue?vue&type=script&lang=js&"
export * from "./TeacherEylf.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEylf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports